// extracted by mini-css-extract-plugin
export default {"vehicleDetailsWrapper":"styles_vehicleDetailsWrapper__ry+j5","container":"styles_container__pMNQ3","backButtonWrapper":"styles_backButtonWrapper__EPcVQ"};